import type * as React from 'react'

import { cn } from '@/shared/helpers/styles.helper'

type Props = React.ComponentProps<'div'> & {
  // Sentence above the ratings
  reassurance: React.ReactNode
}

// Sentence of reassurance, then the ratings given as children, separated by a line
export function ReassuranceReviews({
  reassurance,
  children,
  className,
  ...props
}: Props) {
  return (
    <div
      className={cn('flex flex-col items-center gap-4', className)}
      {...props}
    >
      <p className='text-center text-sm leading-5 font-semibold text-[color:var(--gray-800)] md:text-base'>
        {reassurance}
      </p>
      <hr className='w-full border-[color:var(--gray-200)]' />
      {children}
    </div>
  )
}
